import React, { useState } from "react";
import PropTypes from "prop-types";
import { Field, withFormik } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./reportFilter.data.form";
// import { InputText } from "@de-prado-dev/react-component-library";
import InputText from "../../../utils/InputText";
import InputSelect from "../../../utils/InputSelect";
import {
  FilterContainer,
  FilterGrid,
  FilterActions,
  FilterButton,
  ClearButton,
} from "./reportFilter.styled";
import { DEPARTMENTS } from "../../../../constants";

const ReportFilterForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, onClean } = props;
  const [isOpen, setIsOpen] = useState(false);

  const currentYear = new Date().getFullYear();
  const years = [];
  for (let index = 0; index < 5; index++) {
    years.push({
      code: currentYear - index,
      label: currentYear - index,
    });
  }

  return (
    <FilterContainer>
      <div className="accordion" id="orderFilter">
        <div className="accordion-item">
          <h2 className="accordion-header" id="flush-headingOne">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseOne"
              aria-expanded="false"
              aria-controls="flush-collapseOne"
            >
              {t("forms.evaluation.filter")}
            </button>
          </h2>
          <div
            id="flush-collapseOne"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#orderFilter"
          >
            <div className="accordion-body">
              <form onSubmit={handleSubmit} autoComplete="off">
                <div className="row">
                  <div className="col-3">
                    <Field
                      id="department"
                      name="department"
                      labelField={t("forms.evaluation.labels.department")}
                      component={InputSelect}
                      placeholder=""
                      optionLabel="label"
                      optionValue="code"
                      options={DEPARTMENTS.map((item) => ({
                        ...item,
                        label: t(item.label),
                      }))}
                      classNamePrefix="dark"
                      addOptionEmpty
                    />
                  </div>
                  <div className="col-3">
                    <Field
                      id="year"
                      name="year"
                      labelField={t("forms.evaluation.labels.year")}
                      component={InputSelect}
                      placeholder=""
                      optionLabel="label"
                      optionValue="code"
                      options={years.map((item) => ({
                        ...item,
                        label: t(item.label),
                      }))}
                      classNamePrefix="dark"
                      addOptionEmpty
                      classNameContainer="flex-grow-1"
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-12 d-flex justify-content-end">
                    <FilterButton type="submit" className="me-2">
                      <i className="fas fa-search"></i>
                    </FilterButton>
                    <ClearButton
                      type="button"
                      onClick={() => onClean(props.resetForm)}
                      title={t("cleanFilter")}
                    >
                      <i className="fas fa-trash"></i>
                    </ClearButton>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </FilterContainer>
  );
};

ReportFilterForm.propTypes = {
  handleSubmit: PropTypes.func,
  onClean: PropTypes.func,
};

const ReportFilterFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: validationDataModel,
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "ReportFilterForm",
})(ReportFilterForm);

export default ReportFilterFormF;
